import React from 'react'
import { Box, Flex } from 'rebass'
import styled, { withTheme } from 'styled-components'
import { object, node } from 'prop-types'

const FlexWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  max-width: ${(props) => props.theme.content.max.width};
  margin-left: auto;
  margin-right: auto;
`
const CenterContent = (props) => (
  <FlexWrapper
    bg={props.bg || props.theme.colors.white}
    flexWrap="wrap"
    {...props}
  >
    <Box width="100%" mx={[2, 2]}>
      {props.children}
    </Box>
  </FlexWrapper>
)

CenterContent.protoTypes = {
  theme: object,
  children: node
}

export default withTheme(CenterContent)
